import React from 'react';
import PropTypes from 'prop-types';

// The 6×10 chevron used inside dashboard buttons ("Set up ›", "Confirm ›") and,
// flipped, for "‹ Back".
const Chevron = ({ direction, color }) => (
  <svg
    width="6"
    height="10"
    viewBox="0 0 6 10"
    fill="none"
    aria-hidden="true"
    style={{ transform: direction === 'left' ? 'rotate(180deg)' : undefined, flexShrink: 0 }}
  >
    <path
      d="M1 1L5 5L1 9"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

Chevron.propTypes = {
  direction: PropTypes.oneOf(['left', 'right']),
  color: PropTypes.string,
};

Chevron.defaultProps = {
  direction: 'right',
  color: 'currentColor',
};

export default Chevron;
